export default "__VITE_ASSET__Ct3sGRzG__"